export const HIDE_NOTIFICATION = "EP/HIDE_NOTIFICATION";

export interface HideNotificationAction {
    readonly type: typeof HIDE_NOTIFICATION;
}

export const hideNotification = (): HideNotificationAction => ({
    type: HIDE_NOTIFICATION,
});
